import httpClient from "./httpClient";

export async function listarRegrasWebhookJoin() {
  const response = await httpClient.get("/api/webhooks/join/regras");
  return Array.isArray(response.data) ? response.data : [];
}

export async function criarRegraWebhookJoin(payload) {
  const response = await httpClient.post("/api/webhooks/join/regras", payload);
  return response.data;
}

export async function atualizarRegraWebhookJoin(id, payload) {
  const response = await httpClient.put(`/api/webhooks/join/regras/${id}`, payload);
  return response.data;
}

export async function removerRegraWebhookJoin(id) {
  await httpClient.delete(`/api/webhooks/join/regras/${id}`);
}
